import { registerQuery } from 'data-fetching-client';
import { fetchSpacesClient } from '../clients/fetchSpacesClient';
export const SPACES = 'spaces';
export const fetchSpaces = registerQuery({
  fieldName: SPACES,
  fetcher: fetchSpacesClient
});